import { FC } from "react";
import { Box } from "@material-ui/core";
import { useStyles } from "./styles";
import ShiftTrackerListHead from "./ShiftReportListContent/ShiftReportsListHead";
import ShiftTrackerListTable from "./ShiftReportListContent/ShiftReportsListTable";

const ShiftReportListPage: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <ShiftTrackerListHead/>
      <Box className={classes.contentBox}>
        <ShiftTrackerListTable/>
      </Box>
    </Box>
  );
};

export default ShiftReportListPage;
